import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Client } from 'src/app/models/client.model';
import { OrderModel } from 'src/app/models/order.model';
import { RefundModel } from 'src/app/models/refund.model';
import { CurrentRefundService } from 'src/app/services/data/current-refund.service';
import { DbService } from 'src/app/services/data/idb.service';
import { ConnectionManagerService } from 'src/app/services/storage/connection-manager.service';

@Component({
  selector: 'app-refund-edit',
  templateUrl: './refund-edit.component.html',
  styleUrls: ['./refund-edit.component.scss'],
})
export class RefundEditComponent implements OnInit, OnDestroy {
  private db?: DbService;

  subs: Subscription[] = [];
  orderInfo: OrderModel | undefined;
  buypoint: Client | undefined;
  refund?: RefundModel;
  isAdmin = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cnmng: ConnectionManagerService,
    public returnCur: CurrentRefundService
  ) {
    this.isAdmin = cnmng.isAdmin();
  }

  ngOnInit() {
    let ignore = 0;
    const s1 = this.cnmng.activeServerObservable().subscribe((x) => {
      ignore++;
      if (ignore > 1) {
        this.router.navigateByUrl('/orders');
      }
      this.cnmng.getDb().then((db) => {
        if (db) {
          this.db = db;
          this.init();
        }
      });
    });

    this.subs.push(s1);
  }

  init() {
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (!id) {
        return;
      }
      this.returnCur.init(id);

      this.returnCur.return$.subscribe((ret) => {
        if (ret) {
          this.refund = ret;

          if (ret.statusId !== 1) {
            this.router.navigate(['/refundinfo', ret.id]);
          }

          if (this.refund.orderId) {
            this.initOrder(this.refund.orderId);
          }
          if (this.refund.buypointId) {
            this.initBuypoint(this.refund.buypointId);
          }
        }
      });
    });
  }

  initOrder(orderId: string) {
    this.db?.get('orders', orderId).then((data) => {
      this.orderInfo = data;
    });
  }

  initBuypoint(clientId: string) {
    this.db?.getClient(clientId).subscribe((c) => {
      this.buypoint = c;
    });
  }

  refundChanged() {
    this.router.navigate(['/refunds'])
  }

  ngOnDestroy(): void {
    this.subs.forEach((x) => x.unsubscribe());
    this.subs = [];
    this.returnCur.unsubAll();
  }
}
